import * as types from '../constants/chartConstants';
import appConstants from '../appConstants';
import moment from 'moment';
const initialState = {
  localstorageUpdated: 0,
  flag: 0,
  message: 'Loading...',
  isChartDataNull: false
};

const updateChartValue = (chartValue, timeUnit) => {
  const data = [];
  const arr = chartValue;
  if (chartValue) {
    arr.map(item => {
      const obj = {};
      obj.Price = item.price;
      alert(timeUnit);
      const timeXAxis = new Date(item.key * timeUnit * 1000); // given date convert to UTC
      obj.Time = timeXAxis.toLocaleTimeString(); // UTC convert to local time
      data.push(obj);
    });
  }
  return data;
};

const formatDateTradeDate = (dataArray) => {
  dataArray.slice().forEach((data, index, object) => {
    data.date = new Date(data.tradeDate);
    let day = new Date(data.tradeDate).getUTCDate();
    let year = new Date(data.tradeDate).getUTCFullYear();
    let month = new Date(data.tradeDate).getUTCMonth();
    data.date = new Date(year, month, day, 0, 0, 0, 0);
    // if ( Object.prototype.toString.call(data.date) === "[object Date]" ) {
    //   // it is a date
    //   if ( isNaN( data.date.getTime() ) ) {
    //     // invalid date
    //     dataArray.splice(object.length - 1 - index, 1);
    //   }
    // }
    // if (data.oa === null) {
    //   data.open = 0;
    // }
    // else {
    //   data.open = data.oa;
    // }
    // if (data.ha === null) {
    //   data.high = 0;
    // }
    // else {
    //   data.high = data.ha;
    // }
    // if (data.la === null) {
    //   data.low = 0;
    // }
    // else {
    //   data.low = data.la;
    // }
    // if (data.ca === null) {
    //   data.close = 0;
    // }
    // else {
    //   data.close = data.ca;
    // }
  });
  return dataArray;
};


export default function (state = initialState, action) {
  switch (action.type) {
    case types.LOAD_CHART:
      return {
        ...state,
      };
    case types.LOAD_CHART_SUCCESS:
      return {
        ...state,
        chartValue: updateChartValue(action.result.data, action.initialState.timeUnit)
      };
    case types.LOAD_CHART_FAILURE:
      return {
        ...state,
      };
    case types.LINE_CHART:
      return {
        ...state,
      };
    case types.LINE_CHART_SUCCESS:
      if (action.result.data.length > 0) {
        let lineChartValue = action.result.data;
        localStorage.setItem('lineChartDataLSObj', JSON.stringify({
          lineChartValue: lineChartValue,
          isChartDataNull: false,
          flag: 0,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        }));
        return {
          ...state,
          flag: 0,
          lineChartValue: lineChartValue,
          isChartDataNull: false,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        };
      } else {
        let lineChartValue = [];
        localStorage.setItem('lineChartDataLSObj', JSON.stringify({
          lineChartValue: lineChartValue,
          flag: 0,
          isChartDataNull: true,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        }));
        return {
          ...state,
          flag: 0,
          lineChartValue: [],
          isChartDataNull: true,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        };
      }
    case types.LINE_CHART_FAILURE: 
      return {
        ...state,
        respQueryParamString: action.initialState.queryParamString,
        flag: 1,
        message: 'No Data Available',
      };
    case types.CANDLESTICK_CHART:
      return {
        ...state,
      };
    case types.CANDLESTICK_CHART_SUCCESS:
      if (action.result.data.length > 0) {
        //let CandleStickChartValue = formatDateTradeDate(action.result.data);
        let CandleStickChartValue = action.result.data;
        localStorage.setItem('CandleStickChartDataLSObj', JSON.stringify({
          CandleStickChartValue: CandleStickChartValue,
          isChartDataNull: false,
          flag: 0,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        }));
        return {
          ...state,
          flag: 0,
          CandleStickChartValue: CandleStickChartValue,
          isChartDataNull: false,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        };
      } else {
        let CandleStickChartValue = [];
        localStorage.setItem('lineChartDataLSObj', JSON.stringify({
          CandleStickChartValue: CandleStickChartValue,
          flag: 0,
          isChartDataNull: true,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        }));
        return {
          ...state,
          flag: 0,
          CandleStickChartValue: [],
          isChartDataNull: true,
          respQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        };
      }
    case types.CANDLESTICK_CHART_FAILURE:
      return {
        ...state,
        respQueryParamString: action.initialState.queryParamString
      };
    case types.HISTORICAL_CHART:
      return {
        ...state,
      };
    case types.HISTORICAL_CHART_SUCCESS:
      if (action.result.data.length > 0) {
        let historicalData = formatDateTradeDate(action.result.data);
        // let historicalData = action.result.data;
        //historicalData =moment(action.result.data).local().format(appConstants.actTimeDateTimeFormatter);
        localStorage.setItem('historicalDataLSObj', JSON.stringify({
          historicalData: historicalData,
          flag: 0,
          isChartDataNull: false,
          historicalRespQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        }));
        return {
          ...state,
          flag: 0,
          historicalData: historicalData,
          isChartDataNull: false,
          historicalRespQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        };
      } else {
        localStorage.setItem('historicalDataLSObj', JSON.stringify({
          historicalData: [],
          flag: 1,
          message: 'No Data Available',
          isChartDataNull: true,
          historicalRespQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        }));
        return {
          ...state,
          flag: 1,
          message: 'No Data Available',
          historicalData: [],
          isChartDataNull: true,
          historicalRespQueryParamString: action.initialState.queryParamString,
          destinationUniqueId: action.initialState.uniqueId
        };
      }
    case types.HISTORICAL_CHART_FAILURE:
      return {
        ...state,
      };
    case types.LOCAL_STORAGE_UPDATED:
      return {
        ...state,
        localstorageUpdated: Date.now()
      };
    default:
      return state;
  }
}
